/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Offline_Title7Inputs */

const en_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-first architecture`)
};

const ar_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية غير متصلة أولًا`)
};

const bn_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অফলাইন-ফার্স্ট আর্কিটেকচার`)
};

const de_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-First-Architektur`)
};

const es_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura sin conexión`)
};

const fr_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture hors ligne d'abord`)
};

const pt_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura off-line primeiro`)
};

const zh_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线优先架构`)
};

const tr_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çevrimdışı öncelikli mimari`)
};

const ru_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономная архитектура`)
};

const pl_svc_mobile_app_development_offline_title7 = /** @type {(inputs: Svc_Mobile_App_Development_Offline_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura oparta na trybie offline`)
};

/**
* | output |
* | --- |
* | "Offline-first architecture" |
*
* @param {Svc_Mobile_App_Development_Offline_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_offline_title7 = /** @type {((inputs?: Svc_Mobile_App_Development_Offline_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Offline_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "de") return de_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "es") return es_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_offline_title7(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_offline_title7(inputs)
	return en_svc_mobile_app_development_offline_title7(inputs)
});
export { svc_mobile_app_development_offline_title7 as "svc_mobile-app-development_OFFLINE_title" }